import { EmbeddedViewRef } from '@angular/core';
import { DisplayLabel } from '../locale-data.model';

export interface Registrations {
  id: string;
  display_labels: DisplayLabel[];
  program_id: string;
  program: Program;
  portfolio_id: string | null;
  product: Product;
  product_id: string;
  dispatch_forecast: DispatchForecast[];
  EMSReg: EMSRegistration;
}

export interface Product {
  prez_conf: PrezConf;
}

export interface PrezConf {
  display_dispatch_forecast_homepage: boolean;
  display_erp_homepage: boolean;
}

export interface Program {
  id: string;
  display_labels: DisplayLabel[];
}

export interface RegistrationsResponse {
  data: {
    registrations: Registrations[];
  };
  errors?: GraphQLErrorResponse[];
}

export interface GraphQLErrorResponse {
  message: string;
}

export interface DispatchForecast {
  date: string;
  day: string;
  likelihood: Likelihood;
  isAuditWindow: boolean;
  auditText: string;
  isHoliday: boolean;
}

export type Likelihood = 'HIGH' | 'MEDIUM' | 'LOW' | 'NA';
export interface EMSRegistration {
  energy_reduction_plan: string;
}

export const LIKELIHOOD_PRIORITY: Record<Likelihood, number> = {
  HIGH: 3,
  MEDIUM: 2,
  LOW: 1,
  NA: 0,
};
